import { createAsyncThunk } from '@reduxjs/toolkit';
export class HandledAsyncActionError {
    constructor(error) {
        this.error = error;
    }
    getError() {
        return this.error;
    }
}
export const createAsyncActionFactory = () => (name, action) => createAsyncThunk(name, async (...args) => {
    try {
        return await action(...args);
    }
    catch (e) {
        if (e instanceof HandledAsyncActionError) {
            throw e.getError();
        }
        console.error(e);
        throw e;
    }
});
//# sourceMappingURL=redux.js.map